module.exports = __webpack_public_path__ + "static/media/Kalbelauswahl2.cf74d968.png";